// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonBox_wrapper__HaOOV","container":"ButtonBox_container__+vQFH"};